import React, { Component } from "react";

import { Redirect } from "react-router-dom";
import { SearchOptionsContext } from "./SearchOptionsProvider";

class ClearSearchLink extends Component {
  constructor(props) {
    super(props);

    this.state = {
      linkClicked: false
    };
  }

  onClick = e => {
    e.preventDefault();
    e.stopPropagation();

    // console.log("clear");
    // document.getElementById("search-input").blur();
    // document.getElementById("search-input").value = "";

    this.setState({
      linkClicked: true
    });
  };

  render() {
    const { children, ...otherProps } = this.props;
    const { linkClicked } = this.state;

    return (
      <SearchOptionsContext.Consumer>
        {searchOptions =>
          searchOptions.searchTerm ? (
            /* Only really clear search term if there is one to prevent redirecting to same route */
            <a href={"/"} onClick={this.onClick} {...otherProps}>
              {children}

              {linkClicked === true ? <Redirect to={"/"} /> : null}
            </a>
          ) : (
            <a
              href={"/"}
              onClick={e => {
                e.preventDefault();
              }}
              {...otherProps}
            >
              {children}

              {linkClicked === true ? <Redirect to={"/"} /> : null}
            </a>
          )
        }
      </SearchOptionsContext.Consumer>
    );
  }
}

export default ClearSearchLink;
